(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naninha-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
 const desktop = window.matchMedia('(min-width:750px)');
 const setup = () => document.querySelectorAll('.naninha-footer__group').forEach(group => {
   group.open = desktop.matches;
   if (!group.dataset.ready) {
     group.dataset.ready = 'true';
     group.querySelector('summary').addEventListener('click', event => { if(desktop.matches) event.preventDefault(); });
   }
 });
 setup();
 desktop.addEventListener('change', setup);
 document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naninha-reassurance"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('naninha-reassurance')) {
  customElements.define('naninha-reassurance', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const button = this.querySelector('button');
      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naninha-welcome"]) return;
  try {
    
(() => {
  const initialise = () => {
    document.querySelectorAll('.naninha-welcome').forEach(dialog => {
      if (dialog.dataset.initialised) return;
      dialog.dataset.initialised = 'true';
      const preview = new URLSearchParams(location.search).get('naninha_popup') === 'preview' || dialog.dataset.preview === 'true';
      const key = 'naninha-welcome-2026-v2';
      let acknowledged = false;
      try { acknowledged = sessionStorage.getItem(key) === 'yes'; } catch {}
      if (!preview && (dialog.dataset.home !== 'index' || acknowledged)) return;
      let leaving = false;
      let previousFocus;
      const dismiss = event => {
        event?.preventDefault();
        event?.stopPropagation();
        if (leaving) return;
        leaving = true;
        try { if (!preview) sessionStorage.setItem(key, 'yes'); } catch {}
        dialog.classList.add('is-leaving');
        const finish = () => { dialog.close(); if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true}); };
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else setTimeout(finish, 1650);
      };
      dialog.querySelectorAll('button').forEach(button => button.addEventListener('click', dismiss));
      dialog.addEventListener('cancel', dismiss);
      const show = () => {
        if (!dialog.isConnected || dialog.open) return;
        previousFocus = document.activeElement;
        dialog.showModal();
        dialog.focus({preventScroll:true});
      };
      setTimeout(show, preview ? 300 : 900);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();
})();
